import styled from 'styled-components';
import { Box, Flex, Text } from '../../../../ui-kit';
import theme from '../../../../ui-kit/themes/theme';

export const ContentContainer = styled(Box)`
  width: 100%;
`;

export const SummaryInfoRow = styled(Flex)`
  justify-content: space-between;
  width: 100%;
  align-items: center;
  border-radius: 5px;
  margin-bottom: ${({ mb }) => (mb != null ? `${mb}px` : `${theme.space[4]}px`)};
  border-bottom: 1px solid ${theme.colors.snowMountainGrey[100]};
`;

export const InfoColumn = styled(Box)`
  padding: ${theme.space[3]}px 0;
  text-align: center;
  width: 50%;
  &:first-child {
    border-right: 1px solid ${theme.colors.snowMountainGrey[100]};
  }
  &:last-child {
    border-left: 1px solid ${theme.colors.snowMountainGrey[100]};
  }
`;

export const PassDetailsRow = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.space[2]}px;
`;

export const SeasonPassRow = styled(Flex)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: ${theme.space[7]}px;
`;

export const AppliedContainer = styled(Flex)`
  align-items: center;
  gap: 4px;
`;

export const PassTaxesContent = styled(Flex)`
  justify-content: space-between;
  padding: 20px 0;
  margin-top: 20px;
  border-top: 1px solid ${theme.colors.snowMountainGrey[100]};
`;

export const PassTaxesTextLine = styled(Text)`
  font-weight: ${theme.fontWeights.medium};
  color: ${theme.colors.deepLakeBlue[100]};
  font-size: ${theme.fontSizes[0]}px;
`;

export const TotalRow = styled(Flex)`
  height: 100%;
  justify-content: space-between;
  align-items: center;
  padding-top: ${theme.space[4]}px;
  padding-bottom: ${theme.space[4]}px;

  border-top: 1px solid ${theme.colors.deepLakeBlue[20]};
`;

export const ModalBody = styled(Flex)`
  padding: 0px ${theme.space[7]}px;
  flex-direction: column;
`;

export const ModalHeader = styled(Flex)`
  padding: ${theme.space[7]}px;
  color: ${theme.colors.deepLakeBlue[100]};
  align-items: center;
  width: 100%;
  position: relative;
  height: 82px;
  border-bottom: 1px solid ${theme.colors.snowMountainGrey[100]};
`;

export const ModalTitle = styled(Text)`
  font-weight: ${theme.fontWeights.bold};
  color: ${theme.colors.preciousStoneBlue[100]};
  font-size: 18px;
  padding: 0px;
  flex: 1;
  text-align: center;
  line-height: 24px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 26px;
  top: 30px;
  cursor: pointer;
  border: none;
  background: transparent;
  padding: 0;
  display: flex;
  align-items: center;

  &:focus-visible {
    outline: 2px solid ${theme.colors.preciousStoneBlue[100]};
    outline-offset: 2px;
    border-radius: 4px;
  }
`;

export const ModalContent = styled(Box)`
  overflow-x: hidden;
`;
